import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { CmhEnergyProductionConfigurationState, InitialState } from './types'

const namespaced: boolean = true

export const cmhEnergyProductionConfiguration: Module<CmhEnergyProductionConfigurationState, RootState> = {
  namespaced,
  state: InitialState,
  getters,
  actions,
  mutations
}
